import {
    DataLabel,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-config/element/data-label';
import { ChartUILabelPosition } from '../interface/chart-ui.interface';
import { PieChartConfigHelper, PieChartCoordinate } from './pie-chart-config-helper';
import type { CoordinateOption } from '@tencent/chart/lib/antv/g2/interface';
import type {
    IDoughnutChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/doughnut-chart.interface';
import type {
    IDataLabelProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label/data-label.interface';
import type { IChartRendererConfig } from '@tencent/chart/lib/chart-ui/interface';
import type { ChartUILabel } from '../interface/chart-ui.interface';
import type {
    IChartManualLayout,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';

export class DoughnutChartConfigHelper extends PieChartConfigHelper {
    public getConfig() {
        const chartConf = super.getConfig();
        const [baseRenderConf] = chartConf.subChartRendererConfigs;
        const doughnutChartRenderConfigs: IChartRendererConfig[] = [];

        const seriesCount = this.series.length;
        if (seriesCount > 1) {
            const chartDataList = this.data;
            const { innerRadius = 0, radius = 0 } = baseRenderConf.coordinate?.cfg || {};

            this.series.map((ser, index) => {
                const currentSerData = chartDataList.filter(data => data.serIndex === ser.index);
                const radiusGap = (1 - innerRadius) / seriesCount;
                const calculateRadius = radius * (1 - ((seriesCount - index - 1) * radiusGap));

                const renderConfig: IChartRendererConfig = {
                    ...baseRenderConf,
                    data: currentSerData,
                    id: `${this.id}_${index}`,
                    coordinate: {
                        ...baseRenderConf.coordinate,
                        cfg: {
                            ...baseRenderConf.coordinate?.cfg,
                            radius: calculateRadius,
                            innerRadius: 1 - (radiusGap / calculateRadius),
                        },
                    },
                };
                doughnutChartRenderConfigs.push(renderConfig);
            });

            return {
                ...chartConf,
                subChartRendererConfigs: doughnutChartRenderConfigs,
            };
        }

        doughnutChartRenderConfigs.push(baseRenderConf);
        return {
            ...chartConf,
            subChartRendererConfigs: doughnutChartRenderConfigs,
        };
    }

    protected getCoordinateConfig() {
        const coordinate = new DoughnutCoordinate(this.subChart);
        return coordinate.getConfig();
    }

    protected getDataLabel(label: IDataLabelProperty): DataLabel {
        return new DoughnutDataLabel(label, this.context);
    }
}

class DoughnutCoordinate extends PieChartCoordinate {
    public getConfig(): CoordinateOption {
        const config = super.getConfig();
        const { holeSize, data } = this.subChartProperty as IDoughnutChartProperty;
        const isRadiusCollapsedByLabel = data.some(item => item.label);

        config.cfg = {
            ...config.cfg,
            innerRadius: holeSize / 100,
            radius: isRadiusCollapsedByLabel ? 0.867 : 1,
        };

        return config;
    }
}

class DoughnutDataLabel extends DataLabel {
    public getConfig(): ChartUILabel {
        const config =  super.getConfig();
        if (config && typeof config !== 'boolean') {
            return {
                ...config,
                style: {
                    ...config?.style,
                    textAlign: 'center',
                },
                autoRotate: false,
            };
        }

        return config;
    }

    protected getLabelPosition(
        value: number,
        dataPointLabel: IDataLabelProperty,
        layout?: IChartManualLayout,
    ): ChartUILabelPosition {
        return ChartUILabelPosition.Center;
    }
}
